<template>
  <div id="app">
    <a-layout style="min-height: 100vh">
      <Sidebar />
      <a-layout>
        <a-layout-header style="background: #fff; padding: 0" />

        <a-layout-content>
          <router-view/>
        </a-layout-content>

        <a-layout-footer>
          <a-row justify='space-between'>
            <a-col>
              <a href="https://joeczubiak.com">Joe</a> © {{ current_year }} &mdash; Built by Joe in Los Angeles
            </a-col>
          </a-row>
        </a-layout-footer>
      </a-layout>
    </a-layout>
  </div>
</template>


<script>
export default {
  name: 'App',
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: 'Home',
    // all titles will be injected into this template
    titleTemplate: '%s | Joe\'s Data',
    meta: [
      { name: 'description', content: 'Joe\'s API service is providing free APIs for developers to use.' },
    ],
  },
  computed: {
    current_year() {
      return new Date().getFullYear();
    },
  },
};
</script>

<style lang="less">
#app {
  --color-primary: #049ce8;

  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

  .ant-layout-content {
    background: #ffffff;
  }

  .ant-layout-footer {
    background: #ffffff;
  }

  h1 {
    font-size: 3em;
  }
  h3 {
    font-size: 2em;
  }
  .text-left {
    text-align: left;
  }
  .text-right {
    text-align: right;
  }
  .text-center {
    text-align: center;
  }
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
